/**
 * Created with IntelliJ IDEA.
 * User: abahlk
 * Date: 11.07.13
 * Time: 16:54
 * To change this template use File | Settings | File Templates.
 */

import { EnvGlobalsHandler } from "../../basic/EnvGlobalsHandler";
import { ExternalLoggingConstants } from "../ExternalLoggingConstants";
import { ILODataFacade } from "../facade/ILODataFacade";
import { AbstractLogObject } from "../logObjects/AbstractLogObject";
import { warn } from "../../logging/warn";

export class BasicLogObjectFactory {
    protected _subErrorId: number = -1; // give it a default one, in case .toString() produce error

    private _facade: ILODataFacade;

    // Setter for the data facadae
    public set dataFacade(dataFacade: ILODataFacade) {
        this._facade = dataFacade;
    }

    public create(): AbstractLogObject {
        let lo: AbstractLogObject = new AbstractLogObject();

        // This is set by the concrete factory
        lo.logData.set(ExternalLoggingConstants.PARAM_LOG_EVENT_ID, "");

        lo.logData.set(ExternalLoggingConstants.PARAM_HTML5_TAG, "html5");
        lo.logData.set(ExternalLoggingConstants.PARAM_LOG_TYPE, ExternalLoggingConstants.LOGGING_TYPE_ERROR.toString());
        lo.logData.set(ExternalLoggingConstants.PARAM_SUB_ERROR_ID, this._subErrorId.toString());

        lo.logData.set(ExternalLoggingConstants.PARAM_SOURCESTORE, this._facade.sourceStore);
        lo.logData.set(ExternalLoggingConstants.PARAM_DEVICETYPE, this._facade.deviceType);
        lo.logData.set(ExternalLoggingConstants.PARAM_DEVICECATEGORY, this._facade.deviceCategory);
        lo.logData.set(ExternalLoggingConstants.PARAM_OS, this._facade.os);
        lo.logData.set(ExternalLoggingConstants.PARAM_CLIENT_VERSION, this._facade.clientVersion);
        lo.logData.set(ExternalLoggingConstants.PARAM_ITEM_XML_VERSION, this._facade.itemXMLVersion);
        lo.logData.set(ExternalLoggingConstants.PARAM_IS_IN_BACKGROUND, this._facade.isInBackground);
        lo.logData.set(ExternalLoggingConstants.PARAM_CONNECTION_TYPE, this._facade.connectionType);
        lo.logData.set(ExternalLoggingConstants.PARAM_IS_FIRST_APP_START_AFTER_UPDATE, this._facade.isFirstAppStartAfterUpdate);
        lo.logData.set(ExternalLoggingConstants.PARAM_HTTP_REFERER, this._facade.httpReferer);

        lo.logData.set(ExternalLoggingConstants.PARAM_SESSION_ID, this._facade.sessionId);
        lo.logData.set(ExternalLoggingConstants.PARAM_SESSION_LENGTH, this._facade.sessionLength);
        lo.logData.set(ExternalLoggingConstants.PARAM_GAME_ID, this._facade.gameId);
        lo.logData.set(ExternalLoggingConstants.PARAM_NETWORK_ID, this._facade.networkId);
        lo.logData.set(ExternalLoggingConstants.PARAM_INSTANCE, this._facade.instanceId);
        lo.logData.set(ExternalLoggingConstants.PARAM_COUNTRY_CODE, this._facade.countryCode);
        lo.logData.set(ExternalLoggingConstants.PARAM_LANGUAGE_CODE, this._facade.languageCode);
        lo.logData.set(ExternalLoggingConstants.PARAM_ACCOUNT_ID, this._facade.accountId);
        lo.logData.set(ExternalLoggingConstants.PARAM_PLAYER_ID, this._facade.playerId);
        lo.logData.set(ExternalLoggingConstants.PARAM_IS_FIRST_VISIT_OF_GGS, this._facade.isFirstVisitOfGGS);
        lo.logData.set(ExternalLoggingConstants.PARAM_CDN, this._facade.cdn);
        lo.logData.set(ExternalLoggingConstants.PARAM_CLIENT_TYPE, this._facade.clientType);
        lo.logData.set(ExternalLoggingConstants.PARAM_PERFORMANCE_CATEGORY, this._facade.performanceCategory);

        lo.logData.set(ExternalLoggingConstants.PARAM_HTTP_USER_AGENT, this._facade.browserUserAgent);
        lo.logData.set(ExternalLoggingConstants.PARAM_HTTP_PLATFORM, this._facade.browserPlatform);
        lo.logData.set(ExternalLoggingConstants.PARAM_HTTP_VENDOR, this._facade.browserVendor);

        lo.logData.set(ExternalLoggingConstants.PARAM_UTC_TIME_STAMP, Date.now().toString());

        lo.isEssentialFilled = true;

        return lo;
    }
}
